enum SortOrder {
  'ASC' = 'ASC',
  'DESC' = 'DESC',
}

const oppositeSortOrder = (sortOrder: SortOrder) =>
  sortOrder === SortOrder.ASC ? SortOrder.DESC : SortOrder.ASC

export { SortOrder, oppositeSortOrder }
